import type { RunResult } from '@root/lib';
import type { TFunction } from 'i18next';

// What the player sees in the Result column.
export function runResultLabel(result: RunResult, t: TFunction): string {
  switch (result) {
    case 'WON':
      return t('Win');
    case 'ELIMINATED':
      return t('Eliminated');
    case 'ABANDONED':
      return t('Abandoned');
    case 'EXPIRED':
      return t('Expired');
    case 'PAUSED':
      return t('Paused');
    default:
      return t('In progress');
  }
}

// Figma writes a signed net with a real minus, not a hyphen.
export function signedMoney(money: string, value: number): string {
  if (value > 0) return `+${money}`;
  if (value < 0) return `−${money}`;
  return money;
}
